import { render, staticRenderFns } from "./UserMenuSidebar.vue?vue&type=template&id=187460a2"
import script from "./UserMenuSidebar.vue?vue&type=script&lang=js"
export * from "./UserMenuSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports